import { FC } from "react";
import { Box, ButtonBase, IconButton, Typography, styled } from "@mui/material";
import { IconChevronDown, IconClose, IconFilterList } from "@/assets/icons";
import { background, black, button, divider, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";

type Props = {
  activeFilterCount: number;
  isOpen: boolean;
  onOpen: () => void;
  onClickClear: () => void;
};

export const ReportFilterTrigger: FC<Props> = ({ activeFilterCount, isOpen, onOpen, onClickClear }) => {
  if (activeFilterCount > 0) {
    return (
      <ActiveFilterButton>
        <ButtonBase
          aria-label="フィルタを開く"
          onClick={onOpen}
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        >
          <IconFilterList width={20} height={20} color={black[80]} />
          <Typography variant="cap12Bold" sx={{ mx: 1 }}>
            フィルタ適用数:{" "}
            <Typography component="span" variant="cap12Bold" sx={{ color: button.primary }}>
              {String(activeFilterCount).padStart(2, "0")}
            </Typography>
          </Typography>
        </ButtonBase>
        <IconButton
          aria-label="フィルタをクリア"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onClickClear();
          }}
          sx={{ ml: 0.5, p: 0, "&:hover": { opacity: 0.7, background: "transparent" } }}
        >
          <IconClose width={16} height={16} color={black[80]} />
        </IconButton>
      </ActiveFilterButton>
    );
  }

  return (
    <FilterButton onClick={onOpen} data-open={isOpen}>
      <IconFilterList width={20} height={20} color={black[80]} />
      <Typography variant="cap12Bold" sx={{ color: text.primary, mx: 1 }}>
        フィルタ
      </Typography>
      <IconChevronDown
        width={20}
        height={20}
        color={black[80]}
        style={{
          transition: "transform 0.2s ease",
          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
        }}
      />
    </FilterButton>
  );
};

const FilterButton = styled(ButtonBase)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  padding: theme.spacing(0.5, 1),
  border: `1px solid ${divider.middle}`,
  borderRadius: rounded.sm,
  cursor: "pointer",
  "&:hover, &[data-open=\"true\"]": {
    borderColor: button.primary,
  },
}));

const ActiveFilterButton = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  padding: theme.spacing(0.5, 1),
  border: `1px solid ${button.primary}`,
  borderRadius: rounded.sm,
  background: background.secondary,
}));
